import { AccrualMatchedTransactionDisplay } from "@common/schemas/domains/accrualReview/accrual-review.schema";

export interface SplitMatchGroup {
    key: string;
    matches: AccrualMatchedTransactionDisplay[];
}

export function groupMatchesBySplit(
    matches: AccrualMatchedTransactionDisplay[],
): SplitMatchGroup[] {
    const groupsByKey = new Map<string, SplitMatchGroup>();
    for (const match of matches) {
        const key = String(match.splitParentId ?? match.transactionId);
        const group = groupsByKey.get(key);
        if (group) {
            group.matches.push(match);
            continue;
        }
        groupsByKey.set(key, { key, matches: [match] });
    }
    return [...groupsByKey.values()];
}

export function getDetachTransactionIds(
    matches: AccrualMatchedTransactionDisplay[],
): number[] {
    const splitParent = matches.find(
        (match) => match.transactionId === match.splitParentId,
    );
    if (splitParent) {
        return [splitParent.transactionId];
    }
    return matches.map((match) => match.transactionId);
}
